import type {EmailDomain, EmailDNSAction} from 'src/action-creators/email-dns';

import {keyBy} from 'lodash';

import {RECEIVE, VALIDATE, CREATE, DELETE} from 'src/action-creators/email-dns';


export type EmailDomainState = {
  domains: {
    [domain: string]: EmailDomain;
  };
};

export default (
  state: EmailDomainState = {domains: Object.freeze({})},
  action: EmailDNSAction,
): EmailDomainState => {
  switch (action.type) {
    case RECEIVE: {
      return {domains: keyBy(action.payload, 'domain')};
    }

    case VALIDATE: {
      const {domain, results} = action.payload;
      const domains = state.domains;
      const dns = domains[domain]?.dns;
      if (!dns) {
        return state;
      }
      const updatedDns = Object.fromEntries(
        Object.entries(dns).map(([recordName, recordInfo]: [any, any]) => [
          recordName,
          {
            ...recordInfo,
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<RecordName, { valid: boolean; reason: string | null; }>>'.
            valid: results[recordName].valid,
          },
        ]),
      );
      return {
        ...state,
        domains: {
          ...state.domains,
          [domain]: {
            ...state.domains[domain],
            dns: updatedDns,
          },
        },
      };
    }

    case CREATE: {
      const domain = action.payload;
      return {
        ...state,
        domains: {
          ...state.domains,
          [domain.domain]: domain,
        },
      };
    }

    case DELETE: {
      const domain = action.payload;
      const domains = Object.assign({}, state.domains);
      delete domains[domain];
      return {domains};
    }
  }

  return state;
};
